export default __webpack_public_path__ + "static/media/vp_focus_screen.4da99f6f.jpg";